export enum PortalDesignMode {
  Custom = 0,
  UnifiedCode = 1,
}
